import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChange} from "@angular/core";
import * as moment from "moment";
import { interval,  } from "rxjs";
import { CardPaymentService } from "src/app/services/cardpayment.service";
import { NetworkService } from "src/app/services/network.service";
import { ReceiptService } from "src/app/services/receipt.service";
import { StorageService } from "src/app/services/storage.service";

@Component({
  selector: "app-statusbar",
  templateUrl: "./statusbar.component.html",
  styleUrls: ["./statusbar.component.scss"],
})
export class StatusbarComponent implements OnInit, OnDestroy {

  locale;
  date = moment().format("DD MMM YYYY");
  time = moment().format("HH:mm:ss");

  terminalStatus: string;
  internetStatus: string;

  subs = [];

  receiptNrStream;
  terminalStatusStream;
  networkStatusStream;
  languageStream;

  private receiptNumber: number;

  private dateStream = interval(1000).subscribe(x => this.date = moment().format("DD MMM YYYY"));
  private timeStream = interval(1000).subscribe(x => this.time = moment().format("HH:mm:ss"));

  constructor(private storage: StorageService, private receiptService: ReceiptService,
    private cardPayment: CardPaymentService, private network: NetworkService) { }

  ngOnInit() {
    this.init();
    this.subs.push(this.cardPayment.getStatus().subscribe(status => {
      this.terminalStatus = status;
    }));
    this.subs.push(this.network.appIsOnline$.subscribe(online => {
      if (online) {
        this.internetStatus = "READY";
      } else {
        this.internetStatus = "Offline";
      }
    }));
    this.subs.push(this.storage.languageStream.subscribe(data =>
      moment.locale(data.language)
    ));
    this.subs.push(this.receiptService.receiptNrStream.subscribe(data => {
      this.receiptNumber = data;
    }));
  }

  async init() {
    /* this.storage.languageStream.subscribe(data =>
      moment.locale(data.language)); */
   /*  this.locale = await this.storage.get("language");
    moment.locale(this.locale); */
  }

  getConnectionStatus(statusInp): boolean {
    if (statusInp === "READY") {
      return true;
    } else {
      return false;
    }
  }

  ngOnDestroy(): void {
    this.dateStream.unsubscribe();
    this.timeStream.unsubscribe();
    for (const s of this.subs) {
      if (s && s.unsubscribe) {
        s.unsubscribe();
      }
    }
  }
}
